module.exports = __webpack_public_path__ + "static/media/icon_uncategroized-bofa.d133ae0c.svg";